import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2.5),
    paddingBottom: theme.spacing(8),
  },
  wPB: {
    padding: theme.spacing(2.5),
  },
}));

export const Wrapper = (props) => {
  const classes = useStyles();
  return props.withoutPB ? (
    <div className={classes.wPB} style={props.vh100 && { minHeight: "100vh" }}>
      {props.children}
    </div>
  ) : (
    <div className={classes.root} style={props.vh100 && { height: "100vh" }}>
      {props.children}
    </div>
  );
};
